import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetTrackmanEventsList = () => {
  const trackmanEventsService = useServices().trackmanEventsService;
  return useQuery({
    queryKey: ['trackmanEventsList'],
    queryFn: trackmanEventsService.getTrackmanEvents,
    refetchOnWindowFocus: false,
  });
}